import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-opposizione-atti-esecutivi-view',
  templateUrl: './form-opposizione-atti-esecutivi-view.component.html',
  styleUrls: ['./form-opposizione-atti-esecutivi-view.component.css']
})
export class FormOpposizioneAttiEsecutiviViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
